function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from 'react';
import { EditorBase, EditorHeader, EditorBody, EditorFooter } from "./";
import { makeStyles } from '@material-ui/core/styles';
const useStyles = makeStyles(theme => ({
  root: {
    backgroundColor: "inherit",
    position: "absolute",
    top: 0,
    right: 0,
    bottom: 0,
    left: 0
  },
  body: {
    position: "absolute",
    top: theme.spacing(8),
    right: 0,
    bottom: 0,
    left: 0,
    "& > *:first-child": {
      transition: ".25s ease-out"
    },
    "&[aria-expanded=true]": {
      "& > *:first-child": {
        top: "100%"
      }
    }
  }
}));

const PageEditor = (_ref) => {
  let currentId = _ref.currentId,
      primaryId = _ref.primaryId,
      secondaryId = _ref.secondaryId,
      onToggle = _ref.onToggle,
      children = _ref.children,
      props = _objectWithoutPropertiesLoose(_ref, ["currentId", "primaryId", "secondaryId", "onToggle", "children"]);

  const classes = useStyles();
  const collapsible = primaryId && secondaryId;
  const expanded = collapsible && currentId && currentId.startsWith(secondaryId) || false;
  return React.createElement(EditorBase, {
    className: classes.root
  }, React.createElement(EditorHeader, _extends({}, props, {
    collapsible: collapsible,
    expanded: expanded,
    onToggle: onToggle
  })), React.createElement(EditorBody, {
    className: classes.body,
    square: true,
    elevation: 1,
    expanded: expanded
  }, children), React.createElement(EditorFooter, props));
};

export default PageEditor;